<template>
  <main class="login-form">
    <h1>Ενεργοί Έφεδροι</h1>
    <span>Σύνολο: {{ totalItems }}</span>
    <b-container>

      <b-row class="align-items-center justify-content-between mb-1">
        <!-- Expertise search -->
        <b-col cols="12" lg="auto">
          <b-form-input
              v-model="searchExpertise"
              size="sm"
              placeholder="Αναζήτηση Τομέα Εξειδίκευσης"
              style="width: 28ch;"
          />
        </b-col>

        <b-col cols="12" lg="auto">
          <b-form-input
              v-model="searchEfSa"
              size="sm"
              placeholder="Αναζήτηση ΣΑ (π.χ. 21300)"
              style="width: 22ch;"
          />
        </b-col>

        <!-- Date range filter -->
        <b-col cols="12" lg="auto" class="d-flex align-items-center mt-2 mt-lg-0" style="gap: 0.5rem;">
          <label class="mb-0 text-nowrap" style="font-size:0.875rem;">Από:</label>
          <b-form-input
              v-model="dateFrom"
              type="date"
              size="sm"
              style="width: 16ch;"
          />
          <label class="mb-0 text-nowrap" style="font-size:0.875rem;">Έως:</label>
          <b-form-input
              v-model="dateTo"
              type="date"
              size="sm"
              style="width: 16ch;"
          />
          <b-button size="sm" variant="outline-secondary" @click="clearDateFilter">✕</b-button>
        </b-col>

        <!-- Button aligned right -->
        <b-col cols="12" lg="auto" class="text-md-right mt-2 mt-lg-0">
          <b-button size="sm" variant="success" @click="onRightButtonClick">
            + Κατέβασμα Αρχείου (Φιλτρο)
          </b-button>
          <b-button size="sm" variant="outline-primary" class="ml-2" @click="downloadAllActiveReservistsXlsx">
            + Κατέβασμα Αρχείου (Όλα)
          </b-button>
        </b-col>
      </b-row>

      <!-- 📋 Table with filtered users -->
      <b-col cols="12">
        <b-table
            show-empty
            striped
          :items="changedUsers"
            :fields="fields"
            :current-page="currentPage"
          :per-page="0"
        >
          <template #cell(useSkills)="data">
            {{ data.item.useSkills ? 'ΝΑΙ' : 'ΟΧΙ' }}
          </template>
          <template #cell(actions)="data">
            <b-button size="sm" variant="outline-danger" @click="deactivateActiveReservist(data.item.efSa)">
              Διαγραφή Ενεργού Εφέδρου
            </b-button>
          </template>
        </b-table>

        <!-- 📄 Pagination -->
        <b-pagination
            size="md"
          :total-rows="totalItems"
            v-model="currentPage"
            @change="pageChange"
            :per-page="perPage"
        />
      </b-col>

    </b-container>
  </main>
</template>

<script>
import { HTTP } from "../main.js";

export default {
  data: function () {
    return {
      changedUsers: [],
      searchExpertise: '',
      searchEfSa: '',
      dateFrom: '',
      dateTo: '',
      fields: [
        { label: 'ΣΑ', key: 'efSa', sortable: true },
        { label: 'ΕΠΩΝΥΜΟ', key: 'efEpwnymo', type: 'text', sortable: true },
        { label: 'ΟΝΟΜΑ', key: 'efOnoma', type: 'string', sortable: true },
        {
          label: 'ΑΞΙΟΠΟΙΗΣΗ ΣΤΗΝ ΕΙΡΗΝΗ',
          key: 'useSkills',
          type: 'string',
          sortable: true,
        },
        {
          label: 'ΤΟΜΕΑΣ ΕΞΕΙΔΙΚΕΥΣΗΣ ',
          key: 'expertiseArea',
          type: 'string',
          sortable: false,
        },
        {
          label: 'ΕΞΙΔΙΚΕΥΣΗ',
          key: 'expertiseSkill',
          type: 'string',
          sortable: true,
        },
        {
          label: 'ΠΕΡΙΓΡΑΦΗ ΕΞΕΙΔΙΚΕΥΣΗΣ',
          key: 'skillDesc',
          type: 'string',
          sortable: false,
        },
        {
          label: 'ΗΛΙΚΙΑ',
          key: 'age',
          type: 'integer',
          sortable: false,
        },
        {
          label: 'ΗΜΕΡΟΜΗΝΙΑ ΕΓΓΡΑΦΗΣ',
          key: 'activeReservistDate',
          sortable: true,
          formatter: (value) => value ? new Date(value).toLocaleDateString('el-GR') : '-',
        },
        {
          label: 'ΕΝΕΡΓΕΙΕΣ',
          key: 'actions',
          sortable: false,
        },
      ],
      currentPage: 1,
      perPage: 10,
      totalItems: 0,
    };
  },

  watch: {
    searchExpertise() {
      this.currentPage = 1;
      this.fetchData();
    },
    searchEfSa() {
      this.currentPage = 1;
      this.fetchData();
    },
    dateFrom() {
      this.currentPage = 1;
      this.fetchData();
    },
    dateTo() {
      this.currentPage = 1;
      this.fetchData();
    }
  },

  mounted() {
    this.fetchData();
  },

  methods: {
    pageChange(page) {
      this.currentPage = page;
      this.fetchData();
    },

    async fetchData() {
      let size = this.perPage == null ? 10 : this.perPage;
      let page = this.currentPage == null ? 0 : this.currentPage;

      this.$store.dispatch('loading');

      let pageNum = page - 1;
      let dateParams = '';
      if (this.dateFrom) {
        dateParams += '&dateFrom=' + encodeURIComponent(this.dateFrom);
      }
      if (this.dateTo) {
        dateParams += '&dateTo=' + encodeURIComponent(this.dateTo);
      }
      let expertiseParam = '';
      if (this.searchExpertise) {
        expertiseParam = '&searchExpertise=' + encodeURIComponent(this.searchExpertise);
      }
      let efSaParam = '';
      if (this.searchEfSa) {
        efSaParam = '&searchEfSa=' + encodeURIComponent(this.searchEfSa);
      }

      let url =
          "/admin/find-all-active-reservist?page=" +
          pageNum +
          "&size=" +
          size +
          "&sort=efSa" +
          efSaParam +
          expertiseParam +
          dateParams;

      HTTP.get(url)
          .then((response) => {
            let mappedUsers = (response.data.content || []).map((item) => {
              return {
                ...item,
                skillDesc: item.skillDesc != null ? item.skillDesc : "-",
                expertiseArea:
                    item.expertiseArea != null ? item.expertiseArea : "0",
                expertiseSkill:
                    item.expertiseSkill != null ? item.expertiseSkill : "-",
              };
            });

            this.changedUsers = mappedUsers;
            this.totalItems = response.data.totalElements || 0;
          })
          .catch((error) => {
            console.error(error);
            this.$store.dispatch("stop_loading");
          })
          .finally(() => {
            this.$store.dispatch("stop_loading");
          });
    },

    clearDateFilter() {
      this.dateFrom = '';
      this.dateTo = '';
    },

    async onRightButtonClick() {
      try {
        this.$store.dispatch("loading");

        const params = [];
        if (this.searchExpertise) {
          params.push('searchExpertise=' + encodeURIComponent(this.searchExpertise));
        }
        if (this.dateFrom) {
          params.push('dateFrom=' + encodeURIComponent(this.dateFrom));
        }
        if (this.dateTo) {
          params.push('dateTo=' + encodeURIComponent(this.dateTo));
        }
        if (this.searchEfSa) {
          params.push('searchEfSa=' + encodeURIComponent(this.searchEfSa));
        }

        const query = params.length > 0 ? ('?' + params.join('&')) : '';

        const response = await HTTP.get("/admin/find-all-active-reservist/download" + query, {
          responseType: "blob" // ⬅️ This tells axios to treat it as a file
        });

        const blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

        // Create temporary link to trigger download
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.href = url;

        // Use filename from backend or default one
        const fileName = `active_reservists_${new Date().toISOString().split("T")[0]}.xlsx`;
        link.setAttribute("download", fileName);

        // Trigger download
        document.body.appendChild(link);
        link.click();

        // Cleanup
        link.remove();
        URL.revokeObjectURL(url);

        console.log("✅ File download triggered.");
      } catch (error) {
        console.error("❌ Download failed:", error);
      } finally {
        this.$store.dispatch("stop_loading");
      }
    },

async deactivateActiveReservist(efSa) {
      if (!confirm(`Θέλετε να απενεργοποιήσετε τον ενεργό έφεδρο με ΣΑ ${efSa};`)) {
        return;
      }

      try {
        this.$store.dispatch("loading");
        await HTTP.post(`/admin/active-reservist/deactivate/${encodeURIComponent(efSa)}`);
        await this.fetchData();
      } catch (error) {
        console.error("Deactivate failed:", error);
      } finally {
        this.$store.dispatch("stop_loading");
      }
    },


    async downloadAllActiveReservistsXlsx() {
      try {
        this.$store.dispatch("loading");

        const response = await HTTP.get("/admin/find-all-active-reservist/download", {
          responseType: "blob"
        });

        const blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.href = url;
        link.setAttribute("download", `active_reservists_all_${new Date().toISOString().split("T")[0]}.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(url);
      } catch (error) {
        console.error("❌ Download all failed:", error);
      } finally {
        this.$store.dispatch("stop_loading");
      }
    }
  },



};
</script>

